import { render, staticRenderFns } from "./BorderTableNew.vue?vue&type=template&id=f640eca6&scoped=true&"
import script from "./BorderTableNew.vue?vue&type=script&lang=js&"
export * from "./BorderTableNew.vue?vue&type=script&lang=js&"
import style0 from "./BorderTableNew.vue?vue&type=style&index=0&id=f640eca6&lang=scss&scoped=true&"
import style1 from "./BorderTableNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f640eca6",
  null
  
)

export default component.exports